import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String,
    sidebarMenuEnabled: Boolean
  }

  connect() {
    this.initWidget();
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        isSidebarMenuEnabled: this.hasSidebarMenuEnabledValue ? this.sidebarMenuEnabledValue : true,
        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 10000),

        onPageChange: () => {
          const scroller = this.element.closest(".main-online-onboarding");
          (scroller?.scrollTo ? scroller : window).scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    );
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue);

    if (success) {
      url.searchParams.set("status", "under_analysis");
    }

    setTimeout(() => {
      window.location.replace(url);
    }, delay);
  }
}
